import axios_instance from "../axios.config";

export const ClassAndSectionStrength = async () => {
  const response = await axios_instance.get(
    "/student/class-and-section-strength"
  );
  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return [];
  }
};
